import React from 'react';
import PropTypes from 'prop-types';

import {deviceType, DeviceTypeContext} from './DeviceTypeContext.jsx';

export const DeviceTypeProvider = ({children}) => {
  return (
    <DeviceTypeContext.Provider value={deviceType}>
      {children}
    </DeviceTypeContext.Provider>
  );
};

DeviceTypeProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const DeviceTypeConsumer = DeviceTypeContext.Consumer;

// Helper that only renders children when device is a mobile.
export const MobileOnly = ({children}) => (
  <DeviceTypeContext.Consumer>
    {deviceType => deviceType.isMobile && children}
  </DeviceTypeContext.Consumer>
);

MobileOnly.propTypes = {
  children: PropTypes.node.isRequired
};

// Helper that only renders children when device is a desktop.
export const DesktopOnly = ({children}) => (
  <DeviceTypeContext.Consumer>
    {deviceType => deviceType.isDesktop && children}
  </DeviceTypeContext.Consumer>
);

DesktopOnly.propTypes = {
  children: PropTypes.node.isRequired
};
